import {fitAPI} from '../../api/apiFit';
import moment from 'moment';
import { setFetching,setCurrentUser,setGlobalError,updateAccessToken } from './appReducer';
import 'moment/locale/ru';

//const gyms = require('./init.json');
//const schAtt = require('./schatd.json');

export const periodFilters = {
    PERIOD_DAY: "PERIOD_DAY",
    PERIOD_WEEK: "PERIOD_WEEK",
    PERIOD_MONTH: "PERIOD_MONTH"
}

let initialState = {
    gyms:[],
    periodF:[
        {id:periodFilters.PERIOD_DAY, name:"День"},
        {id:periodFilters.PERIOD_WEEK, name:"Неделя"},
        {id:periodFilters.PERIOD_MONTH, name:"Месяц"}
    ],
    currentPeriod:{ //текущие сутки (локальный часовой пояс)
        periodId: periodFilters.PERIOD_DAY, 
        start:  moment().startOf("day").unix(),
        end:    moment().endOf("day").unix(),
        prevBtnDis:false,	
        nextBtnDis:false
    },
    currentRoom:"",
    schAtt:[],
    addDialogOpen: false,
    addDialogAlert: ""
};

const CHANGE_ACTIVE_PERIOD = "CHANGE_ACTIVE_PERIOD";
const CHANGE_PERIOD_FILTER = "CHANGE_PERIOD_FILTER";
const CHANGE_CURRENT_ROOM = "CHANGE_CURRENT_ROOM";
const SET_GYMS_DATA = "SET_GYMS_DATA";
const SET_SCH_ATT = "SET_SCH_ATT";
const SCH_ATT_RECORD = "SCH_ATT_RECORD";
const SET_OPEN_ADD_DIALOG = "SET_OPEN_ADD_DIALOG";
const SET_ALERT_ADD_DIALOG = "SET_ALERT_ADD_DIALOG";

const scheduleAttendantReducer = (state = initialState, action) => {

    switch (action.type) {
        
        case CHANGE_ACTIVE_PERIOD: {
            return {...state, currentPeriod: action.currentPeriod}
 
        }
        case CHANGE_PERIOD_FILTER: {
            
            return {...state, currentPeriod:{...state.currentPeriod, periodId: action.periodId}}
 
        }
        case CHANGE_CURRENT_ROOM: {
            
            return {...state, currentRoom: action.currentRoom}
 
        }
        case SET_GYMS_DATA: {
            
            return {...state, gyms: action.gymsData}
 
        }
        case SET_SCH_ATT: {
            
            return {...state, schAtt: action.attData}
 
        }
        case SCH_ATT_RECORD: {
            const index = state.schAtt.findIndex(item => item.s === action.shift);
            let schAtt = [...state.schAtt];
            schAtt[index] = {...schAtt[index], d: action.attData};
            return {...state, schAtt }
 
        }
        case SET_OPEN_ADD_DIALOG: {
            
            return {...state, addDialogOpen: action.open}
 
        }

        case SET_ALERT_ADD_DIALOG: {
            
            return {...state, addDialogAlert: action.alert}
 
        }

        default: return state;
    }
}

const changeActivePeriod = (currentPeriod) => ({type: CHANGE_ACTIVE_PERIOD,currentPeriod}); 
export const changePeriodFilter = (periodId) => ({type: CHANGE_PERIOD_FILTER,periodId}); 
const setCurrentRoom = (currentRoom) => ({type: CHANGE_CURRENT_ROOM,currentRoom});
const setGymsData = (gymsData) => ({type: SET_GYMS_DATA,gymsData}); 
const setSchAttData = (attData) => ({type: SET_SCH_ATT,attData});  
export const addDialogSetOpen = (open) => ({type: SET_OPEN_ADD_DIALOG,open});  
const setAlertAddDialog = (alert) => ({type: SET_ALERT_ADD_DIALOG,alert});  

export const setSchAttRecord = (shift, attData) => ({type: SCH_ATT_RECORD,shift,attData});


export const changeCurrentRoom = (roomId)=>{
    return (dispatch)=>{

        dispatch(setCurrentRoom(roomId));
        localStorage.setItem('currentRoom', roomId);

    }
}

export const nextPeriod = (next,periodId)=>{
    return (dispatch,getState)=>{
        
        if (next===0) {
            dispatch(changePeriodFilter(periodId));
            localStorage.setItem('periodFilter', periodId);
        }

        const curPeriod = getState().schAttenReducer.currentPeriod;
        const schAtt = getState().schAttenReducer.schAtt;

        let newPeriod = {};

        if (periodId===periodFilters.PERIOD_DAY) {
            switch (next) {
                case 1: { 
                    newPeriod = {start:moment.unix(curPeriod.start).add(1,'days').unix(),end:moment.unix(curPeriod.end).add(1,'days').unix()};
                    break;
                }
                case -1: { 
                    newPeriod = {start:moment.unix(curPeriod.start).add(-1,'days').unix(),end:moment.unix(curPeriod.end).add(-1,'days').unix()};
                    break;
                }
                case 0: { 
                    newPeriod = {start:curPeriod.start,end:moment.unix(curPeriod.start).endOf('day').unix()};
                    break;
                }
                default: {
                    break;
                }
            }
        };

        if (periodId===periodFilters.PERIOD_WEEK) {
            switch (next) {
                case 1: { 
                    newPeriod = {start:moment.unix(curPeriod.start).add(7,'days').unix(),end:moment.unix(curPeriod.end).add(7,'days').unix()};
                    break;
                }
                case -1: { 
                    newPeriod = {start:moment.unix(curPeriod.start).add(-7,'days').unix(),end:moment.unix(curPeriod.end).add(-7,'days').unix()};
                    break;
                }
                case 0: { 
                    newPeriod = {start:moment.unix(curPeriod.start).startOf('week').unix(),end:moment.unix(curPeriod.start).endOf('week').unix()};
                    break;
                }
                default: {
                    break;
                }
            }
        }

        if (periodId===periodFilters.PERIOD_MONTH) {
            
            switch (next) {
                case 1: { 
                    newPeriod = {
                        start:moment.unix(curPeriod.start).add(1,'months').startOf('month').unix(),
                        end:moment.unix(curPeriod.end).add(1,'months').endOf('month').unix()
                    };
                    break;
                }
                case -1: { 
                    newPeriod = {
                        start:moment.unix(curPeriod.start).add(-1,'months').startOf('month').unix(),
                        end:moment.unix(curPeriod.end).add(-1,'months').endOf('month').unix()
                    };
                    break;
                }
                case 0: { 
                    newPeriod = {
                        start:moment.unix(curPeriod.start).startOf('month').unix(),
                        end:moment.unix(curPeriod.start).endOf('month').unix()
                    };
                    break;
                }
                default: {
                    break;
                }
            }
        }

        ;

        let prevBtnDis = false; 
        let nextBtnDis = false;
        if (newPeriod.start<=schAtt[0].s) prevBtnDis=true;
        if (newPeriod.end>=schAtt[schAtt.length-1].s) nextBtnDis=true;
        newPeriod={...newPeriod,prevBtnDis,nextBtnDis};

        dispatch(changeActivePeriod({...curPeriod,...newPeriod}));    
    }
}

export const initFitData = ()=>{
    return async (dispatch, getState)=>{

        //фильтр периода из localStorage,
        //а значение периода от текущей локальной даты
        const currentPeriodFilter = localStorage.getItem('periodFilter');
        if (currentPeriodFilter) {
            let momentPeriod;
            switch (currentPeriodFilter) {
                case periodFilters.PERIOD_DAY: momentPeriod="day"; break;
                case periodFilters.PERIOD_WEEK: momentPeriod="week"; break;
                case periodFilters.PERIOD_MONTH: momentPeriod="month"; break;
                default: momentPeriod="day";   
            }
            const curPeriod = getState().schAttenReducer.currentPeriod;
            dispatch(changeActivePeriod({...curPeriod,periodId:currentPeriodFilter,start: moment().startOf(momentPeriod).unix(),end:moment().endOf(momentPeriod).unix()}));      
        }
        
        
        dispatch(setFetching(true));
        await dispatch(updateAccessToken());
        const token = getState().appReducer.accessToken.access_token;

        fitAPI.getInitData(token)
            .then(response=>{
                //console.log(response);
                dispatch(setGymsData(response.result.gyms));

                //восстановление значения currentRoom из localStorage,
                //если это значение есть в полученных данных
                const currentRoom = localStorage.getItem('currentRoom');
                const gyms = response.result.gyms;
                const currentRoomAvailable = (currentRoom,gyms) => {
                    for (var i=0;i<gyms.length;i++) {
                        if (gyms[i].rooms.findIndex(item => item.guid === currentRoom)) return true;
                    }
                    return false;
                }
                if (currentRoom&&currentRoomAvailable(currentRoom,gyms)) {
                    dispatch(setCurrentRoom(currentRoom));
                } else {
                    dispatch(changeCurrentRoom(response.result.gyms[0].rooms[0].guid));
                };
                //-----------
                
                dispatch(setCurrentUser(response.result.curStaff));
                dispatch(setFetching(false));
            })
            .catch(err =>{
                console.log(err);
                dispatch(setFetching(false));
                dispatch(setGlobalError(true));
            });
        
    }
}

export const getScheduleAttendant = ()=>{
    return async (dispatch, getState)=>{
        dispatch(setFetching(true));

        await dispatch(updateAccessToken());
        const token = getState().appReducer.accessToken.access_token;

        const roomGuid = getState().schAttenReducer.currentRoom;

        if (roomGuid) {
            fitAPI.getSchatdData(token, roomGuid)
                .then(response=>{
                    //console.log(response);
                    dispatch(setSchAttData(response.result.schAtt));
                    dispatch(setFetching(false));
                })
                .catch(err =>{
                    //console.log(err);
                    dispatch(setSchAttData([]));
                    dispatch(setFetching(false));
                });
        }
    }
}

export const saveScheduleRecord = (data, oldData) => {
    return async (dispatch, getState) => {
    
        await dispatch(updateAccessToken());
        const token = getState().appReducer.accessToken;
      
        fitAPI.saveSchAtt(token.access_token, data, oldData)
            .then(response => {
                if (response.result) {
                    if (response.result.schAtt.length > 0) {
                        dispatch(setSchAttRecord(response.result.schAtt[0].s, response.result.schAtt[0].d));
                        dispatch(addDialogSetOpen(false));
                    }
                } else {
                    dispatch(setAlertAddDialog(response.errors.message));
                }
            })
            .catch(err => {
                //console.log(err);
                dispatch(setAlertAddDialog("Ошибка!"));
            });

    }
}

export const getPDF = ()=>{
    return async (dispatch, getState)=>{

        await dispatch(updateAccessToken());

        const token = getState().appReducer.accessToken.access_token;
        const { currentRoom, currentPeriod } = getState().schAttenReducer;

        fitAPI.getSrcPDF(token, currentRoom, currentPeriod.start, currentPeriod.end)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `ГрафикДежурств-${currentPeriod.start}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);

                // if (response.errors.code===0) {
                //     //window.open(response.result.src, '_blank');
                // }
            })
            .catch(err => {
                console.log(err);
            });
        
        
    }
}

export default scheduleAttendantReducer;